interface EmptyContentTextProps {
    message: string
}

export const EmptyContentText = ({ message }: EmptyContentTextProps) => {
    return (
        <div className="alert alert-info" style={{ textAlign: 'center' }}>
            {message}
        </div>
    )
}
